import React, { useState, useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { API_URL } from "../Config";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import "jspdf-autotable";
import config from "../common/Config";

const InvoicePaymentAllocation = ({
  customer_id: propCustomerId,
  fromDate: propFromDate,
  toDate: propToDate,
  onClose,
  onSuccess,
  API_URL: propApiUrl,
  accessToken: propAccessToken,
  customerName: propCustomerName,
  isModal = false,
}) => {
  const navigate = useNavigate();
  const { customer_id: paramCustomerId } = useParams();
  console.log(propCustomerName);
  const customer_id = propCustomerId || paramCustomerId;
  const accessToken = propAccessToken || localStorage.getItem("accessToken");
  const apiUrl = propApiUrl || API_URL;

  const [fromDate, setFromDate] = useState(propFromDate || "");
  const [toDate, setToDate] = useState(propToDate || "");
  const [allocationAmount, setAllocationAmount] = useState(0);
  const [order, setOrder] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [invoiceAllocationAmount, setInvoiceAllocationAmount] = useState(0);
  const [checkedInvoices, setCheckedInvoices] = useState(new Set());
  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptData, setReceiptData] = useState(null);

  // Add state for company details
  const [companyDetails, setCompanyDetails] = useState(null);

  // Fetch company details from API on mount
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${apiUrl}/ws-get-company-details-v2`, {
          method: "GET",
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        const data = await response.json();
        // Use data.data.company_details for company info
        if (data && data.success && data.data && data.data.company_details) {
          setCompanyDetails(data.data.company_details);
        }
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };
    fetchCompanyDetails();
  }, [apiUrl, accessToken]);

  const printReceiptDirectly = async (receiptInfo) => {
    const doc = new jsPDF();
    const margin = 14;
    let y = 15;

    // Define logo variables
    // const logoWidth = 40;
    // const logoHeight = 18;
    // // Use logo from API if available, else fallback
    // const logoUrl = companyDetails?.logo || `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;

    // Use company details from API if available, else fallback to static
    const company = companyDetails || {};
    const companyName = company.company_name || "";
    // Address as a single line or split by '|' for multi-line
    const addressLines = company.address
      ? company.address.split("|").map((line) => line.trim())
      : [""];
    const phone = company.phone || "";
    const email = company.email || "";
    const companyNo = company.company_no || "";
    const vatNo = company.vat_no || "";
    const website = company.website || "";

    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
    const logoWidth = 40;
    const logoHeight = 18;

    let logoImg = null;
    try {
      const response = await fetch(logoUrl);
      const blob = await response.blob();
      logoImg = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch {
      logoImg = null;
    }

    if (logoImg) {
      try {
        doc.addImage(logoImg, "PNG", margin, y, logoWidth, logoHeight);
      } catch (e) {}
    }

    const detailsX = margin + logoWidth + 5;
    let detailsY = y + 2;

    doc.setFontSize(13);
    doc.setFont(undefined, "bold");
    doc.text(companyName, detailsX, detailsY);
    detailsY += 6;

    doc.setFontSize(8);
    doc.setFont(undefined, "normal");
    addressLines.forEach((line) => {
      doc.text(line, detailsX, detailsY);
      detailsY += 4;
    });

    detailsY += 2;
    doc.text(
      `Phone No : ${phone}${email ? ` | Email : ${email}` : ""}`,
      detailsX,
      detailsY
    );
    detailsY += 4;
    const formatDate = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };
    // Only print companyNo/vatNo/website if present
    let extraLine = [];
    if (companyNo) extraLine.push(`Company No : ${companyNo}`);
    if (vatNo) extraLine.push(`VAT No : ${vatNo}`);
    if (website) extraLine.push(`Website : ${website}`);
    if (extraLine.length > 0) {
      doc.text(extraLine.join(" | "), detailsX, detailsY);
    }

    y += logoImg ? logoHeight + 8 : detailsY - y + 4;
    const summaryRows = [
      [
        {
          content: `Customer: ${receiptInfo?.customer_name || "N/A"}`,
          colSpan: 2,
          styles: { fontStyle: "bold" },
        },
        {
          content: "Amt Available",
          styles: { fontStyle: "bold", textAlign: "right" },
        },
        Number(allocationAmount).toFixed(2),
      ],
      [
        { content: "Allocated Amount", styles: { fontStyle: "bold" } },
        Number(
          receiptInfo?.allocated_amount || invoiceAllocationAmount
        ).toFixed(2),
        { content: "Date", styles: { fontStyle: "bold", textAlign: "right" } },
        formatDate(receiptInfo?.date || new Date()),
      ],
    ];

    doc.autoTable({
      body: summaryRows,
      startY: y,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 2,
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      columnStyles: {
        0: { cellWidth: 70 },
        1: { cellWidth: 35, halign: "right" },
        2: { cellWidth: 40 },
        3: { cellWidth: 35, halign: "right" },
      },
      didParseCell: function (data) {
        if (
          data.cell.raw &&
          data.cell.raw.styles &&
          data.cell.raw.styles.fontStyle === "bold"
        ) {
          data.cell.styles.fontStyle = "bold";
        }
        if (data.column.index === 1 || data.column.index === 3) {
          data.cell.styles.halign = "right";
        }
      },
    });

    // Calculate correct allocated amount per invoice
    const tableColumn = [
      "Sr. No.",
      "Invoice Number",
      "Status",
      "Grand Total",
      "Previous Paid Amt",
      "Allocated",
    ];
    const tableRows = [];

    (receiptInfo?.invoices || selectedInvoices).forEach((inv, index) => {
      const grandTotal = Number(
        inv.grandTotal || inv.balance || inv.allocated || 0
      );
      const previousPaidAmt = Number(inv.previous_paid || inv.paid || 0);
      const allocatedAmt = Number(inv.paid || inv.allocated || 0);

      tableRows.push([
        index + 1, // ✅ Sr. No.
        String(inv.reference_no || inv.invoiceNumber || inv.id || ""),
        String(inv.payment_status || "Allocated"),
        grandTotal.toFixed(2),
        previousPaidAmt.toFixed(2),
        allocatedAmt.toFixed(2),
      ]);
    });

    const safeTableRows = tableRows.filter(
      (row) => Array.isArray(row) && row.length === tableColumn.length
    );

    // ✅ Totals
    const totalGrand = safeTableRows.reduce(
      (sum, r) => sum + parseFloat(r[3] || 0),
      0
    );
    const totalPrevPaid = safeTableRows.reduce(
      (sum, r) => sum + parseFloat(r[4] || 0),
      0
    );
    const totalAllocated = safeTableRows.reduce(
      (sum, r) => sum + parseFloat(r[5] || 0),
      0
    );

    // ✅ Footer row (shifted by one column because of Sr. No.)
    safeTableRows.push([
      {
        content: "Total",
        colSpan: 3,
        styles: { halign: "right", fontStyle: "bold" },
      },
      totalGrand.toFixed(2),
      totalPrevPaid.toFixed(2),
      totalAllocated.toFixed(2),
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: safeTableRows,
      startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 5 : y,
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      columnStyles: {
        0: { cellWidth: 15, halign: "center" }, // Sr. No.
        1: { cellWidth: 40 }, // Invoice Number
        2: { cellWidth: 25 }, // Status
        3: { cellWidth: 30, halign: "right" }, // Grand Total
        4: { cellWidth: 35, halign: "right" }, // Previous Paid Amt
        5: { cellWidth: 35, halign: "right" }, // Allocated
      },
    });

    doc.autoPrint(); // trigger print mode
    window.open(doc.output("bloburl"), "_blank");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedInvoices.length === 0) {
      Swal.fire("Warning", "Please select at least one invoice", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("customer_id", customer_id);
    selectedInvoices.forEach((invoice) => {
      formData.append("ids[]", invoice.invoiceNumber);
      formData.append("reference_no[]", invoice.reference_no);
      formData.append("sources[]", invoice.source);
    });

    try {
      const response = await fetch(`${apiUrl}/SubmitInvoicePaymentAllocation`, {
        method: "POST",
        headers: { Authorization: `Bearer ${accessToken}` },
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        // Map API response to receipt format for printing
        const receiptInvoices = (data.invoices || []).map((inv) => ({
          reference_no: inv.reference_number,
          grandTotal: inv.grand_total,
          previous_paid: inv.previous_paid,
          paid: inv.paid,
          payment_status: inv.payment_status,
          allocated: inv.paid, // Use paid as allocated for this API
        }));

        // Try to get customer name from API response, fallback to prop or selectedInvoices
        const customerNameFromApi =
          data.customer_name ||
          data.customer ||
          (data.data && (data.data.customer_name || data.data.customer)) ||
          propCustomerName ||
          selectedInvoices[0]?.customer_name ||
          selectedInvoices[0]?.customer ||
          "N/A";

        const receiptInfo = {
          customer_name: customerNameFromApi,
          date: new Date().toLocaleDateString(),
          allocated_amount: receiptInvoices.reduce(
            (sum, inv) => sum + parseFloat(inv.paid || 0),
            0
          ),
          invoices: receiptInvoices,
        };
        setReceiptData(receiptInfo);

        const result = await Swal.fire({
          title: "Success",
          text:
            data.message ||
            "Invoice payment allocation submitted successfully!",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Yes, Print Receipt",
          cancelButtonText: "No, Continue",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#6c757d",
          customClass: {
          confirmButton: 'swal-confirm-btn',
          cancelButton: 'swal-cancel-btn'
        }
        });

        if (result.isConfirmed) {
          printReceiptDirectly(receiptInfo);
        }

        setSelectedInvoices([]);
        setInvoiceAllocationAmount(0);
        setCheckedInvoices(new Set());

        $("#pushtosagelist .select-checkbox").prop("checked", false);

        fetchData();

        if (onSuccess) onSuccess();

        if (!isModal) {
          navigate("/account/customer_accounts");
        }
      } else {
        Swal.fire("Error", "Failed to allocate payment", "error");
      }
    } catch (error) {
      console.error("Error submitting allocation:", error);
      Swal.fire(
        "Error",
        "An error occurred while submitting allocation",
        "error"
      );
    }
  };

  const fetchData = async () => {
    if (!customer_id) return;

    const formData = new FormData();
    formData.append("searchByFromdate", fromDate);
    formData.append("searchByTodate", toDate);
    formData.append("customer_id", customer_id);

    try {
      const response = await fetch(`${apiUrl}/InvoicePaymentAllocation`, {
        method: "POST",
        headers: { Authorization: `Bearer ${accessToken}` },
        body: formData,
      });

      const data = await response.json();
      if (data.success && data.data) {
        setOrder(data.data.customer_order || []);
        setAllocationAmount(data.data.allocation_amout[0]?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // FIX 1: Separate calculation function for allocation amount
  const calculateAllocationAmount = (invoices) => {
    return invoices.reduce((total, invoice) => {
      return total + parseFloat(invoice.grandTotal || 0);
    }, 0);
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate, customer_id]);

  useEffect(() => {
    if (order.length > 0) {
      if ($.fn.DataTable.isDataTable("#pushtosagelist")) {
        $("#pushtosagelist").DataTable().destroy();
      }

      const table = $("#pushtosagelist").DataTable({
        pageLength: 50,
        data: order,
        columns: [
          {
            data: null,
            title: "S.No",
            width: "50px",
            render: (data, type, row, meta) => meta.row + 1,
          },
          { data: "invoice_date", title: "Date" },
          { data: "reference_no", title: "Invoice Number" },
          {
            data: "grand_total",
            title: "Amount",
            render: (data) => parseFloat(data).toFixed(2),
            className: "text-end",
          },
          {
            data: "paid",
            title: "Paid",
            render: (data) => parseFloat(data).toFixed(2),
            className: "text-end",
          },
          {
            data: "balance",
            title: "Balance",
            render: (data) => parseFloat(data).toFixed(2),
            className: "text-end",
          },
          {
            data: null,
            title: "Allocate",
            render: (row) =>
              `<input type="checkbox" class="select-checkbox" data-id="${row.id}" data-reference_no="${row.reference_no}" data-grandtotal="${row.balance}" data-source="${row.source}" />`,
            orderable: false,
          },
        ],
        destroy: true,
        searching: true,
        info: true,
        lengthChange: true,
        dom: '<"toprow d-flex justify-content-between align-items-end mb-3"<"left"l><"right"f>>rt<"bottomrow d-flex justify-content-between mt-2"<"left"i><"right"p>>',
        language: {
          lengthMenu: "Show _MENU_",
          info: "Showing _START_ to _END_ of _TOTAL_ invoices",
          infoEmpty: "No invoices found",
          infoFiltered: "(filtered from _MAX_ total invoices)",
        },
        searchDelay: 300,
        search: {
          caseInsensitive: true,
        },
      });

      $("#customSearchBox").on("keyup", function () {
        table.search(this.value).draw();
      });

      // FIX 2: Improved checkbox handling with proper state updates
      $("#pushtosagelist").on("change", ".select-checkbox", function () {
        const invoiceNumber = $(this).data("id");
        const reference_no = $(this).data("reference_no");
        const grandTotal = parseFloat($(this).data("grandtotal"));
        const source = $(this).data("source");
        const isChecked = $(this).is(":checked");

        // Get all currently checked boxes
        const checkedBoxes = $("#pushtosagelist .select-checkbox:checked");

        // Calculate new allocated amount
        let newAllocated = 0;
        const newSelectedInvoices = [];

        checkedBoxes.each(function () {
          const invoiceData = {
            invoiceNumber: $(this).data("id"),
            reference_no: $(this).data("reference_no"),
            grandTotal: parseFloat($(this).data("grandtotal")),
            source: $(this).data("source"),
          };
          newSelectedInvoices.push(invoiceData);
          newAllocated += invoiceData.grandTotal;
        });

        // Validation logic
        if (isChecked) {
          if (grandTotal > parseFloat(allocationAmount)) {
            if (newSelectedInvoices.length > 1) {
              Swal.fire(
                "Warning",
                "Partial allocation is allowed only for a single invoice at a time.",
                "warning"
              );
              $(this).prop("checked", false);
              return;
            }
          } else {
            if (newAllocated > parseFloat(allocationAmount)) {
              Swal.fire(
                "Warning",
                "Allocated amount cannot be greater than available amount",
                "warning"
              );
              $(this).prop("checked", false);
              return;
            }
          }
        }

        // FIX 3: Update state immediately with correct values
        setSelectedInvoices(newSelectedInvoices);
        setInvoiceAllocationAmount(newAllocated.toFixed(2));
        setCheckedInvoices(
          new Set(newSelectedInvoices.map((inv) => inv.invoiceNumber))
        );
      });

      return () => {
        if ($.fn.DataTable.isDataTable("#pushtosagelist")) {
          $("#pushtosagelist").DataTable().destroy();
        }
      };
    }
  }, [order, allocationAmount]); // FIX 4: Add allocationAmount as dependency

  // FIX 5: Remove the duplicate useEffect that was overriding the calculation
  // This useEffect was causing the issue by recalculating after the checkbox event
  // useEffect(() => {
  //   const newTotal = selectedInvoices.reduce((total, inv) => total + inv.grandTotal, 0);
  //   setInvoiceAllocationAmount(newTotal.toFixed(2));
  // }, [selectedInvoices]);

  const renderReceiptModal = () => {
    return (
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        style={{ background: "rgba(0,0,0,0.5)", zIndex: 9999 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title w-100 text-center">
                Payment Allocation Receipt
              </h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowReceipt(false)}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div id="allocation-receipt-print">
                <div style={{ textAlign: "center", marginBottom: "20px" }}>
                  <h5>Payment Allocation Receipt</h5>
                </div>
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th style={{ width: "30%" }}>Customer</th>
                      <td>
                        {receiptData?.customer_name ||
                          receiptData?.customer ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Date</th>
                      <td>
                        {receiptData?.date || new Date().toLocaleDateString()}
                      </td>
                    </tr>
                    <tr>
                      <th>Allocated Amount</th>
                      <td>
                        {Number(
                          receiptData?.allocated_amount ||
                            invoiceAllocationAmount
                        ).toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h6 style={{ marginTop: "20px", marginBottom: "10px" }}>
                  Allocated Invoices
                </h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Invoice Number</th>
                      <th className="text-end">Allocated Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(receiptData?.invoices || selectedInvoices).map(
                      (inv, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>
                            {inv.invoiceNumber || inv.reference_no || inv.id}
                          </td>
                          <td className="text-end">
                            {Number(inv.allocated || inv.grandTotal).toFixed(2)}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>

                <div style={{ marginTop: "20px", textAlign: "right" }}>
                  <strong>
                    Total Allocated:{" "}
                    {Number(
                      receiptData?.allocated_amount || invoiceAllocationAmount
                    ).toFixed(2)}
                  </strong>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary me-2"
                onClick={() => setShowReceipt(false)}
              >
                Close
              </button>
              <button className="btn btn-primary" onClick={handlePrintReceipt}>
                Print Receipt
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handlePrintReceipt = () => {
    if (receiptData) {
      printReceiptDirectly(receiptData);
    }
  };

  const handleCloseReceipt = () => {
    setShowReceipt(false);
    setReceiptData(null);
    fetchData();
  };

  const renderMainContent = () => {
    return (
      <div>
        <div
          style={{ position: "relative", top: "55px", left: "130px" }}
          className="mb-3"
        >
          <div className="row align-items-end mb-3">
            <div className="col-md-3">
              <label className="form-label">
                <b>Amt Available</b>
              </label>
              <input
                type="text"
                className="form-control text-end"
                value={Number(allocationAmount).toFixed(2)}
                readOnly
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">
                <b>Amt Allocated</b>
              </label>
              <input
                type="text"
                className="form-control text-end"
                value={invoiceAllocationAmount}
                readOnly
                style={{
                  backgroundColor:
                    parseFloat(invoiceAllocationAmount) > 0
                      ? "#e8f5e8"
                      : "#fff",
                  fontWeight:
                    parseFloat(invoiceAllocationAmount) > 0 ? "bold" : "normal",
                }}
              />
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered" id="pushtosagelist">
            <thead>
              <tr>
                <th style={{ width: "50px" }}>S.No</th>
                <th>Date</th>
                <th>Invoice Number</th>
                <th className="text-end">Amount</th>
                <th className="text-end">Paid</th>
                <th className="text-end">Balance</th>
                <th>Allocate</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>

        <div className="text-end mt-3">
          {isModal && (
            <button className="btn btn-secondary me-2" onClick={onClose}>
              Close
            </button>
          )}
          <button
            className="acceptbtn"
            type="button"
            onClick={handleSubmit}
            disabled={selectedInvoices.length === 0}
            style={{
              opacity: selectedInvoices.length === 0 ? 0.5 : 1,
              cursor: selectedInvoices.length === 0 ? "not-allowed" : "pointer",
            }}
          >
            Allocation Payment
          </button>
        </div>
      </div>
    );
  };

  if (isModal) {
    return renderMainContent();
  }

  return (
    <div className="main-container">
      <div className="container-fluid" style={{ marginTop: "-70px" }}>
        {showReceipt ? (
          <div
            className="allocation-receipt"
            style={{
              maxWidth: 600,
              margin: "30px auto",
              border: "1px solid #ccc",
              padding: 24,
              background: "#fff",
            }}
          >
            <h4 style={{ textAlign: "center", marginBottom: 20 }}>
              Payment Allocation Receipt
            </h4>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Customer</th>
                  <td>
                    {receiptData?.customer_name ||
                      receiptData?.customer ||
                      "N/A"}
                  </td>
                </tr>
                <tr>
                  <th>Date</th>
                  <td>
                    {receiptData?.date || new Date().toLocaleDateString()}
                  </td>
                </tr>
                <tr>
                  <th>Allocated Amount</th>
                  <td>
                    {Number(
                      receiptData?.allocated_amount || invoiceAllocationAmount
                    ).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
            <h5 style={{ marginTop: 20 }}>Allocated Invoices</h5>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Invoice Number</th>
                  <th>Invoice Amount</th>
                  <th>Allocated</th>
                </tr>
              </thead>
              <tbody>
                {(receiptData?.invoices || selectedInvoices).map((inv, idx) => (
                  <tr key={idx}>
                    <td>{inv.reference_no}</td>
                    <td>{Number(inv.grandTotal).toFixed(2)}</td>
                    <td>{Number(inv.allocated).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="text-end mt-3">
              <button
                className="btn btn-secondary me-2"
                onClick={handleCloseReceipt}
              >
                Close
              </button>
              <button className="btn btn-primary" onClick={handlePrintReceipt}>
                Print Receipt
              </button>
            </div>
          </div>
        ) : (
          renderMainContent()
        )}
      </div>
    </div>
  );
};

export default InvoicePaymentAllocation;
